import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { analyticsEvent } from '../../../../actions/analytics';

import moment from 'moment';
import { selectBookmarksByDate } from '../../../../selectors/bookmarks';
import { selectPage } from '../../../../selectors/content';
import connect from '../../../connect';
import { createLoader } from '../../../../loader';
import { bookmarkResource } from '../../../../resources/bookmarks';

class Bookmarks extends React.Component {
    static propTypes = {
        analyticsEvent: PropTypes.func.isRequired,
        content: PropTypes.object,
        groups: selectBookmarksByDate.PropType,
        bookmarkedPages: PropTypes.object.isRequired,
        open: PropTypes.bool.isRequired,
        closeMenu: PropTypes.func.isRequired,
    };

    onClick = () => {
        this.props.analyticsEvent('bookmark', 'click');
        this.props.closeMenu();
    };

    renderBookmarks = group => {
        const { bookmarkedPages } = this.props;
        const tabIndex = this.props.open ? 0 : -1;
        return group.bookmarks.map(bookmark => {
            const page = bookmarkedPages[bookmark.page];
            const linkTo = `content-${bookmark.content_id}/address/${bookmark.page}`;
            return (
                <li key={bookmark.page}>
                    <Link
                        to={linkTo}
                        onClick={this.onClick}
                        tabIndex={tabIndex}
                    >
                        Page {page.label}
                    </Link>
                </li>
            );
        });
    };

    renderGroups = () => {
        let bookmarkCount = 0;
        this.props.groups
            .map(group => {
                return group.bookmarks.length;
            })
            .forEach(item => {
                bookmarkCount += item;
            });

        if (bookmarkCount == 0) {
            return <h1>You have no bookmarks.</h1>;
        }

        return this.props.groups.map(group => {
            if (group.bookmarks.length > 0) {
                return (
                    <dl className="nav nav-list" key={group.label}>
                        <dt className="nav-header">{group.label}</dt>
                        <dd>
                            <ul className="page-list">
                                {this.renderBookmarks(group)}
                            </ul>
                        </dd>
                    </dl>
                );
            }
            return null;
        });
    };

    render() {
        return (
            <div role="tabpanel" aria-labelledby="bookmarks-tab">
                {this.renderGroups()}
            </div>
        );
    }
}

const dateGroups = [
    {
        label: 'Today',
        date: moment()
            .startOf('day')
            .toDate(),
    },
    {
        label: 'Yesterday',
        date: moment()
            .startOf('day')
            .subtract(1, 'days')
            .toDate(),
    },
    {
        label: 'Earlier this week',
        date: moment()
            .startOf('day')
            .subtract(7, 'days')
            .toDate(),
    },
    {
        label: 'Older',
        date: new Date(0),
    },
];

const BookmarksLoader = createLoader({
    component: Bookmarks,
    resources: {
        groups(options) {
            const { content } = options.props;
            return {
                ...bookmarkResource(options, content),
                find() {
                    return selectBookmarksByDate(
                        options.rootState,
                        content,
                        dateGroups
                    );
                },
            };
        },
    },
});

function mapStateToProps(state, props) {
    const groups = selectBookmarksByDate(state, props.content, dateGroups);
    const bookmarkedPages = {};

    groups.forEach(group =>
        group.bookmarks.forEach(bookmark => {
            const page = selectPage(state, props.content, bookmark.page);
            bookmarkedPages[bookmark.page] = page;
        })
    );

    return {
        rootState: state,
        groups,
        bookmarkedPages,
    };
}

export default connect(
    mapStateToProps,
    {
        analyticsEvent,
    },
    null,
    { pure: true }
)(BookmarksLoader);



// WEBPACK FOOTER //
// ./src/components/engage_reader/navbar/toc/bookmarks.jsx